import React, { useState, useMemo, useEffect } from "react";
import { MdEdit, MdDelete } from "react-icons/md";
import PageLayout from "../../../Layouts/PageLayout/PageLayout";
import Table from "../../../components/common/Table/Table";
import Button from "../../../components/common/Button/Button";
import InputSearch from "../../../components/common/Inputs/InputSearch/InputSearch";
import { FiDownload } from "react-icons/fi";
import { GrAdd } from "react-icons/gr";
import { LuArrowDownUp } from "react-icons/lu";
import { getApiInstance } from "../../../utils/api";
import { mapWithReferences, mapList } from "../../../utils/utils";
import { useZone } from "../../../context/ZoneContext";

// const comunidadesData = [
//   { id: 1, nombre: "Andalucía", pais: "España" },
//   { id: 2, nombre: "Cataluña", pais: "España" },
//   { id: 3, nombre: "Madrid", pais: "España" },
//   { id: 4, nombre: "Valencia", pais: "España" },
//   { id: 5, nombre: "Galicia", pais: "España" },
//   { id: 6, nombre: "País Vasco", pais: "España" },
//   { id: 7, nombre: "Castilla y León", pais: "España" },
//   { id: 8, nombre: "Castilla-La Mancha", pais: "España" },
//   { id: 9, nombre: "Aragón", pais: "España" },
//   { id: 10, nombre: "Extremadura", pais: "España" },
//   { id: 11, nombre: "Asturias", pais: "España" },
//   { id: 12, nombre: "Murcia", pais: "España" },
//   { id: 13, nombre: "Baleares", pais: "España" },
//   { id: 14, nombre: "Canarias", pais: "España" },
//   { id: 15, nombre: "Cantabria", pais: "España" },
// ];

const columnasComunidades = [
  {
    key: "id",
    label: "Comunidad",
    sortable: true,
    visible: false,
  },
  { key: "codComunidad", label: "Comunidad", visible: false },
  {
    key: "comunidad",
    label: "Comunidad",
    sortable: true,
    visible: true,
  },
  {
    key: "pais",
    label: "País",
    sortable: true,
    visible: true,
  },
  { key: "codPais", label: "País", visible: false },
];

const filterFields = [
  { key: "comunidad", label: "Comunidad", type: "multiselect" },
  { key: "pais", label: "País", type: "multiselect" },
];

export default function Comunidades() {
  const [comunidades, setComunidades] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [paises, setPaises] = useState([]);
  const { selectedZone } = useZone();

  useEffect(() => {
    fetchPaises();
    fetchComunidades();
  }, [selectedZone]);

  const fetchComunidades = async () => {
    setLoading(true);
    const api = getApiInstance();

    try {
      let comunidadesData = [];

      console.log("Fetching comunidades...");
      const response = await api.get(`/api/Comunidades/GetComunidadesByZona/${selectedZone.value}`);
      comunidadesData = response.data;
      console.log("Comunidades fetched:", comunidadesData);

      const mappings = [
        {
          fieldToMatch: "codPais",
          fieldToAdd: "pais",
          referenceList: paises,
          referenceKey: "id",
          referenceValue: "value",
        },
      ];

      setComunidades(comunidadesData)

      setError(null);
    } catch (err) {
      setError(
        "No se han podido cargar las comunidades. Vuelve a intentarlo más tarde."
      );
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const fetchPaises = async () => {
    setLoading(true);
    const api = getApiInstance();

    try {
      let paisesData = [];

      const response = await api.get(`/api/Paises/GetPaisesByZona/${selectedZone.value}`);
      paisesData = response.data;

      setPaises([...mapList(paisesData, "pais", "codPais", "codPais")]);

      console.log("Paises data fetched:", paisesData);
      console.log("Mapped paises:", mapList(paisesData, "pais", "codPais", "codPais"));

      setError(null);
    } catch (err) {
      setError(
        "No se han podido cargar los países. Vuelve a intentarlo más tarde."
      );
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  if (error)
    return <div className="muebles-pages__error-message">Error: {error}</div>;

  return (
    <PageLayout
      title="Comunidades"
      subtitle="Gestión de comunidades autónomas disponibles en el sistema"
    >
      <Table
        columns={columnasComunidades}
        dataTable={comunidades}
        showCheckboxes={true}
        actions={["Eliminar", "Editar"]}
        noResultsMessage="No se han encontrado comunidades."
        searchTerms={["Comunidad", "País"]}
        formElements={[
          {
            elements: [
              {
                name: "comunidad",
                type: "text",
                label: "Nombre",
                placeholder: "Introduce el nombre",
                required: true,
                disabled: false,
                labelVisible: true,
                visible: true,
              },
              {
                name: "codPais",
                type: "select",
                label: "País",
                placeholder: "Introduce el país",
                options: paises,
                required: true,
                disabled: false,
                labelVisible: true,
                visible: true,
              },
            ],
          },
        ]}
        loading={loading}
        filterFields={filterFields}
        elementName="Comunidad"
        keyProp="codComunidad"
        sortProp="comunidad"
        addApiUrl="/api/Comunidades/SetComunidad"
        editApiUrl="/api/Comunidades/EditComunidad"
        deleteApiUrl="/api/Comunidades/DeleteComunidad"
      />
    </PageLayout>
  );
}
